<button mat-stroked-button class="stroked-btn font-size {{ className }}" [disabled]="disabled" [routerLink]="routerLinkName || null" (click)="handleClick()" [style.opacity]="disabled ? 0.2 : 1">
  {{ buttonText }}
</button>
